import * as category from './category'
import * as feature from './feature'
import * as general from './general'

export const fallProtectionHelper = {
  general,
  category,
  feature,
}
